import axios from "axios";
import store from "../redux/store";
import { showToastAction } from "../redux/toastSlice";

export default async function getFormDashboard(projectName, formName) {
    try {
        return await axios.get(`/project/${projectName}/${formName}/dashboard`)
    }
    catch (err) {
        store.dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
    }
}